export default {
  hero_label: 'Company Overview',
  hero_title: 'Company Profile',
  hero_sub1: 'Paving the way for Japan\'s business future',
  hero_sub2: 'as your AI transformation partner.',
  scroll: 'SCROLL',
  section_mission: 'MISSION',
  mission_statement: 'Solving every challenge\nin the AI domain,\nrealizing sustainable\ncorporate growth',
  mission_desc: 'Through our AIX consulting domain, we comprehensively address the challenges companies face with AI. We don\'t stop at strategy—we provide end-to-end execution support to deliver tangible results.',
  vision_title: 'Vision',
  vision_desc: 'As a collective of AI professionals, we lead the strengthening of Japanese companies\' business capabilities and contribute to enhancing competitiveness in global markets. By fusing technology and human potential, we create the next generation of AI-driven organizations.',
  value_title: 'Values',
  value_1_title: 'Customer First',
  value_1_desc: 'We prioritize our clients\' success above all and build long-term partnerships',
  value_2_title: 'Execution Power',
  value_2_desc: 'We don\'t just strategize—we take responsibility for execution',
  value_3_title: 'Continuous Learning',
  value_3_desc: 'We constantly pursue the latest methodologies and technologies',
  value_4_title: 'Teamwork',
  value_4_desc: 'Members with diverse expertise collaborate to deliver the greatest value',
  section_founding: 'FOUNDING STORY',
  founding_title: 'Our Founding',
  founding_desc: 'In January 2025, AIX JAPAN was founded with the conviction to "root AI fundamentally in Japanese business operations." The rapidly evolving wave of AI technology is not a threat but a great opportunity for many companies. However, only a handful are truly reaping the benefits. We set out from Tokyo with the mission to bridge this gap.',
  founder_quote: '"AI is not just a tool—it becomes a new member of the organization. We walk alongside you at the forefront of this transformation."',
  founder_name: 'Representative Director — Akihito Suzuki',
  pillar_1_title: 'Identifying Challenges',
  pillar_1_body: 'We noticed a constant refrain: "We understand the need for AI, but we don\'t know where to start."',
  pillar_2_title: 'Bridging the Gap',
  pillar_2_body: 'There was a lack of experts connecting cutting-edge AI with real-world business operations. We are convinced that this bridging role is our calling.',
  pillar_3_title: 'Developing Talent',
  pillar_3_body: 'Technology adoption alone cannot sustain transformation. We made cultivating AI talent rooted within organizations a founding pillar of our company.',
  section_info: 'COMPANY INFORMATION',
  access_title: 'Access',
  map_link: 'View on Google Maps',
  info_company_name: 'Company Name',
  info_company_name_en: 'Company Name (English)',
  info_founded: 'Founded',
  info_ceo: 'Representative Director',
  info_capital: 'Capital',
  info_address: 'Address',
  info_email: 'Email',
  info_business: 'Business Description',
  info_company_name_value: 'AIX JAPAN Co., Ltd.',
  info_company_name_en_value: 'AIX JAPAN Co., Ltd.',
  info_founded_value: 'January 23, 2025',
  info_ceo_value: 'Akihito Suzuki',
  info_capital_value: 'JPY 5,000,000',
  info_address_value: '2F, Shinjuku Washington Hotel Building Main Tower\n3-2-9 Nishi-Shinjuku, Shinjuku City\nTokyo 160-0023, Japan',
  info_business_value: '◉ AIX Business\nAIX Consulting\nAIX Manager\nAIX Training\nAI Agent Development\n\n◉ Business Development\nStrategic Consulting\nNew Business Development Consulting\n\n◉ IT Services\nIT Consulting\nSystem Development\nInfrastructure Design & Construction\nOperations & Maintenance\nQuality Management\nSecurity\n\n◉ In-house Products\nGenAI All In One Tool Planning, Development & Operations',
  access_route_1: 'Approx. 8 min walk from JR Shinjuku Station South Exit',
  access_route_2: 'Approx. 5 min walk from Toei Oedo Line Tochomae Station',
};